<template>
    <div class="container m-t-10">
        <div class="columns">

            <div v-if="order.status == 'SA'" class="column is-full has-text-centered">
                <h1 class="title has-text-info">Orden en verificacion.</h1>
                <p>Estamos validando que tenemos todo en stock para cumplir la orden</p>
            </div>
            <div v-if="order.status == 'P'" class="column is-full has-text-centered">
                <h1 class="title has-text-info">Orden pendiente.</h1>
                <p>Orden en revision.</p>
            </div>
            <div v-if="order.status == 'A'" class="column is-full has-text-centered">
                <h1 class="title has-text-success">El pago de tu orden a sido creado con exito.</h1>
                <p>En este momento estamos preparandola para que llegue a tus manos.</p>
            </div>

            <div v-if="order.status == 'D'" class="column is-full has-text-centered">
                <h1 class="title has-text-danger">Esta orden a sido cancelada</h1>
                <p>No se pudo concretar la continuidad de esta orden.</p>
            </div>

            <div v-if="order.status == 'R'" class="column is-full has-text-centered">
                <h1 class="title has-text-warning">Orden reembolsada</h1>
                <p>Esta orden fue reembolsada al comprador.</p>
            </div>

            <div v-if="order.status == 'S'" class="column is-full has-text-centered">
                <h1 class="title has-text-success">Tu orden esta en camino!.</h1>
                <p>Ya enviamos la orden, en cualquier momento la tenes en tus manos!.</p>
            </div>

            <div v-if="order.status == 'F'" class="column is-full has-text-centered">
                <h1 class="title has-text-success">Tu orden ya fue entregada</h1>
                <p>Confirmamos que esta orden ya fue entregada al cliente.</p>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props:{
        order:{
            type: Object,
            default: new Object({})
        },
        payment:{
            type:Object,
            default: new Object({})
        },
    }
}
</script>